import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UiModule } from '@ov-suite/ui';
import { TableTopNavMenuComponent } from './table-top-nav-menu.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UiModule,
    RouterModule,
  ],
  declarations: [
    TableTopNavMenuComponent
  ],
  exports: [
    TableTopNavMenuComponent
  ],
  entryComponents: [
    TableTopNavMenuComponent
  ]
})
export class TableTopNavMenuModule {}
